const ROUTER_INDEX_BACK: number = -1;

export default ROUTER_INDEX_BACK;
